import { render, staticRenderFns } from "./fansPendant.vue?vue&type=template&id=4c7e39ef&scoped=true&"
import script from "./fansPendant.vue?vue&type=script&lang=js&"
export * from "./fansPendant.vue?vue&type=script&lang=js&"
import style0 from "./fansPendant.vue?vue&type=style&index=0&id=4c7e39ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e39ef",
  null
  
)

export default component.exports